const doc = [({"ja":({"constantBookingErrorCode":({"unknown":"不明なエラーが発生しました", "no_data":"予約データを取得できませんでした"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;